import { Badge } from "@/components/ui";
import {
  ACCESS_PROGRAM_GROUP,
  CMS_ACCESS_ENROLLMENT_FLAG,
  programTrackDisplayName,
} from "@/constants/AccessProgram";
import { useConfigCatFeatureFlag } from "@/network/useConfigCatFeatureFlag";
import { ClipboardCheck } from "lucide-react";
import type { PatientProgram } from "../types/patientDemographics";

interface EnrolledProgramsProps {
  enrolledPrograms: PatientProgram[];
}

export const EnrolledPrograms = ({
  enrolledPrograms,
}: EnrolledProgramsProps) => {
  const { data: accessFlag } = useConfigCatFeatureFlag(
    CMS_ACCESS_ENROLLMENT_FLAG,
  );
  const accessEnabled = accessFlag === true;
  const accessPrograms = enrolledPrograms.filter(
    ({ group }) => group === ACCESS_PROGRAM_GROUP,
  );

  if (!accessEnabled || accessPrograms.length === 0) {
    return null;
  }

  const tracks = [
    ...new Set(accessPrograms.map(({ type }) => programTrackDisplayName(type))),
  ];

  return (
    <Badge
      className="bg-access text-access"
      data-testid="enrolled-in-access-chip"
    >
      <ClipboardCheck />
      ACCESS {tracks.join(", ")}
    </Badge>
  );
};
